<template>
  <b-card title="تسهیم" sub-title="سرویس تقسیم وجه درگاه">
    <b-modal id="modal-ibns-show" title="وضعیت شماره شبا" ok-title="ارسال برای شاپرک" @ok="inquirysharesheba()"
      cancel-title="بستن">
      <b-alert :show="error.length > 0" variant="danger">
        <p v-for="er in error" v-bind:key="er">{{ er }}</p>
      </b-alert>
    </b-modal>
    <AddCard v-bind:afterdone="getCardList" v-bind:canceled="getCardList"></AddCard>

    <b-modal id="modal_showReseet" title="رسید تراکنش" ok-only ok-title="بازگشت">
      <b-form-group label="برداشت از:">
        <div class="form-control">
          {{ activeReseet.from }}
        </div>
      </b-form-group>
      <b-form-group label="واریز به:">
        <div class="form-control">
          {{ activeReseet.to }}
        </div>
      </b-form-group>
      <b-form-group label="مبلغ:">
        <div class="form-control">
          {{ Number(activeReseet.amount).toLocaleString() }} ريال
        </div>
      </b-form-group>
      <b-form-group label="تاریخ ثبت:">
        <div class="form-control">{{ persDate(activeReseet.created_at) }}</div>
      </b-form-group>
      <b-form-group label="شماره رهگیری">
        <div class="form-control">
          {{ activeReseet.ref_id }}
        </div>
      </b-form-group>
    </b-modal>
    <div class="row" v-if="!dataLoaded">
      <div class="col-md-4">
        <b-skeleton type="button" class="mt-2" width="100%" height="180px"></b-skeleton>
      </div>
      <div class="col-md-4">
        <b-skeleton type="button" class="mt-2" width="100%" height="180px"></b-skeleton>
      </div>
      <div class="col-md-4">
        <b-skeleton type="button" class="mt-2" width="100%" height="180px"></b-skeleton>
      </div>
      <div class="col-md-4">
        <b-skeleton type="button" class="mt-2" width="100%" height="180px"></b-skeleton>
      </div>
      <div class="col-md-4">
        <b-skeleton type="button" class="mt-2" width="100%" height="180px"></b-skeleton>
      </div>
      <div class="col-md-4">
        <b-skeleton type="button" class="mt-2" width="100%" height="180px"></b-skeleton>
      </div>
    </div>
    <div v-if="dataLoaded">
      <b-row v-if="activeMerchant == null">
        <div class="col-md-4" v-for="item in gatewayList" v-bind:key="item.id">
          <b-card no-body class="mt-2" style="cursor: pointer" @click="setActiveMerchant(item)">
            <b-card-body>
              <div class="row">
                <div class="col-md-3 col-sm-3">
                  <b-img :src="item.fileUrl" fluid></b-img>
                </div>
                <div class="col-md-9 col-sm-9">
                  <h4>{{ item.website_name }}</h4>
                  <b-row>
                    <b-col class="p-3"> مبلغ قابل برداشت: </b-col>
                    <b-col class="text-center text-light p-3" style="background-color: #0d7d65; border-radius: 5px">
                      {{ Number(item.willpayfuture).toLocaleString() }} ريال
                    </b-col>
                  </b-row>
                  <b-row class="mt-5">
                    <b-col class="p-3"> مبلغ در حال تسویه: </b-col>
                    <b-col class="text-center text-dark p-3" style="background-color: #f3f6f9; border-radius: 5px">
                      {{ Number(item.waiting).toLocaleString() }} ريال
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </b-row>
      <b-row v-if="activeMerchant != null">
        <b-table responsive foot-clone :fields="[
          {
            key: 'shaba_number',
            label: 'حساب',
            formatter: (value, row, item) => {
              return value + ' (' + item.nickname + ')';
            },
          },
          {
            key: 'amount',
            label: 'مبلغ',
            formatter: (value, row, item) => {
              return Number(value).toLocaleString();
            },
          },
          { key: 'action', label: 'عملیات' },
        ]" :items="sharingList">
          <template #cell(action)="row">
            <b-button variant="danger" pill style="padding: 3px" @click="remove(row.item.id)"><b-icon
                icon="trash"></b-icon></b-button>
            <b-button variant="info" pill class="ml-2" style="padding: 3px" @click="print(row.item.id)"><b-icon
                icon="printer"></b-icon></b-button>
          </template>
          <template #foot(shaba_number)>
            <b-input-group>
              <template v-slot:append>
                <b-button variant="success" @click="$bvModal.show('addcard-modal')">جدید</b-button>
              </template>
              <v-select-s style="width: calc(100% - 60px)" dir="rtl" :options="userCards" :reduce="(item) => item.value"
                label="text" @input="onChange(itemToSave)" :value="itemToSave.detail_id" v-model="itemToSave.detail_id"
                :autocomplete="'on'"></v-select-s>
              <!-- <b-form-select
              :options="userCards"
              v-model="itemToSave.detail_id"
            ></b-form-select> -->
            </b-input-group>
          </template>
          <template #foot(amount)>
            <NumberSeprator v-model="itemToSave.amount"> </NumberSeprator>
          </template>
          <template #foot(action)>
            <b-button variant="success" :disabled="disabledbtn" @click="save">
              ذخیره
            </b-button>
          </template>
        </b-table>

        <b-col class="pb-5">
          <div class="mt-3">
            <b-button variant="danger" @click="back"> بازگشت </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <v-snackbar v-model="snackbar" color="danget" top left>
      مبلغ درخواست شده بیشتر از موجودی می باشد
    </v-snackbar>
  </b-card>
</template>
<script>
import AddCard from "../BankCards/AddCard";
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
import NumberSeprator from "../../components/numberSeprator";
import vSelect from "vue-select";
import routesMap from '@/helpers/routesMap'
import _ from "lodash";
export default {
  name: "Sharing",
  components: {
    MDDropdown,
    AddCard,
    NumberSeprator,
    "v-select-s": vSelect,
  },
  data() {
    return {
      snackbar: false,
      disabledbtn: false,
      selectedVal: 0,
      itemToSave: {},
      sharingList: [],
      activeReseet: {},
      gatewayList: [],
      dataLoaded: false,
      activeMerchant: null,
      sharing: [],
      userCards: [],
      doc: {},
      doc_details: [],
      sumPrice: 0,
      remainMoney: 0,
      master_details: [],
      showSuccess: false,
      error: false,
      recompute: 0,
      routesMap,
    };
  },
  mounted() {
    httpHelper.setAuth();
    httpHelper
      .getData("getSattlableGateways")
      .then((response) => {
        this.gatewayList = response.result;
        gatewayList.forEach((gateway) => {
          httpHelper.getImage(gateway.logo).then((res) => {
            this.$set(gateway, 'fileUrl', res.result.url);
          });
        });
        this.dataLoaded = true;
      })
      .finally(() => { });
    this.getCardList();
  },
  computed: {
    getDocDetails() {
      this.recompute;
      var index = 0;
      var data = this.doc_details.filter(function (o) {
        o.ref = index;
        index++;
        return o.bed == 0 && (o.deleted == null || o.deleted == false);
      });
      return data;
    },
  },
  methods: {
    inquirysharesheba() {
      this.error = [];
      var items = {};
      items.gatewayid = this.activeMerchant.id;
      items.paymentgatewayibns = this.itemToSave;
      return;
      httpHelper.postData("inquirysharesheba", items).then((res) => {
        if (res.success == true) {
          this.itemToSave = {};
          this.disabledbtn = false;
        } else {
          for (var key in res.error) {
            res.error[key].forEach((element) => {
              this.error.push(element);
            });
          }
        }
      });
    },
    onChange(itemSelected) {
      // this.error = [];
      // var items = {};
      // items.gatewayid = this.activeMerchant.id;
      // items.paymentgatewayibns = itemSelected;
      // httpHelper.postData("existibnsgateway", items).then((res) => {
      //   if (res.success == true) {
      //     this.disabledbtn = false;
      //   } else {
      //     this.disabledbtn = true;

      //     for (var key in res.error) {
      //       res.error[key].forEach((element) => {
      //         this.error.push(element);
      //       });
      //     }
      //     this.$bvModal.show("modal-ibns-show");
      //   }
      // });
    },
    persDate(date) {
      return persianDate.getDateByFormat(date);
    },
    print(id) {
      httpHelper.getData("getsharingdetails/" + id).then((res) => {
        this.activeReseet = res.result;
        this.$bvModal.show("modal_showReseet");
      });
    },
    remove(id) {
      httpHelper.getData("removeSharing/" + id).then((res) => {
        this.setActiveMerchant(this.activeMerchant);
      });
    },
    save() {
      httpHelper
        .postData("sharing/" + this.activeMerchant.id, this.itemToSave)
        .then((res) => {
          if (res.success == true) {
            this.itemToSave = {};
            this.setActiveMerchant(this.activeMerchant);
          } else {
            this.snackbar = true;
          }
        });
    },
    back() {
      this.activeMerchant = null;
      this.itemToSave = {};
    },
    getCardList() {
      httpHelper.getData("usercards").then((response) => {
        this.userCards = response.result
          .filter(function (o) {
            return o.detailed.length > 0;
          })
          .map((item) => {
            return {
              text: item.shaba_number + " (" + item.nickname + ")",
              value: item.detailed[0].id,
            };
          });
      });
    },
    setActiveMerchant(merchant) {
      this.activeMerchant = merchant;
      this.getCardList();
      httpHelper.getData("sharing/" + merchant.id).then((res) => {
        this.sharingList = res.result;
      });
      // httpHelper
      //   .getData("getSettlmentForGateway?id=" + merchant.id)
      //   .then((remainMoney) => {
      //     this.sumPrice = _.sumBy(remainMoney.result, function (o) {
      //       return o.payable;
      //     });
      //   });
    },
  },
};
</script>
